/**
 * Shared vocabulary for the Home v2 tracker detail screens (Sleep, Steps).
 */
/** The `Day | Week | Month | Year` segmented control on a tracker detail screen. */
export var TrackerPeriod;
(function (TrackerPeriod) {
    TrackerPeriod["DAY"] = "day";
    TrackerPeriod["WEEK"] = "week";
    TrackerPeriod["MONTH"] = "month";
    TrackerPeriod["YEAR"] = "year";
})(TrackerPeriod || (TrackerPeriod = {}));
/** Direction of the current bucket against the previous one, for insight blocks. */
export var TrackerTrend;
(function (TrackerTrend) {
    TrackerTrend["UP"] = "UP";
    TrackerTrend["DOWN"] = "DOWN";
    TrackerTrend["FLAT"] = "FLAT";
})(TrackerTrend || (TrackerTrend = {}));
/**
 * The word on the Sleep overview card ("Good"). Derived from the night's
 * duration against the user's goal — never stored, so changing the goal
 * re-bands past nights the same way the screen would.
 */
export var SleepQualityBand;
(function (SleepQualityBand) {
    SleepQualityBand["POOR"] = "POOR";
    SleepQualityBand["FAIR"] = "FAIR";
    SleepQualityBand["GOOD"] = "GOOD";
    SleepQualityBand["EXCELLENT"] = "EXCELLENT";
})(SleepQualityBand || (SleepQualityBand = {}));
